<template>
  <div class="home" style="position: relative;">
    <Title>{{ t('meta.siteName') }}</Title>
    <!-- <button @click="to()">0000</button> -->
    <div class="content" id="fullpage">
       <div class="section">
        <Header @titleClick="titleClick" @menuClick="menuClick" :headerBgc="state.headerBgc" :showLogo="state.showLogo" :boxShadows="state.boxShadows" :title-color="state.titleColor"/>
        <Banner/>
       </div>
       <div class="section">
        <div class="page2">
          <div class="title">{{ $t('home.aboutTitle') }}</div>
          <div class="detail"  data-aos="fade-up">
            <div class="line1">{{ $t('home.aboutLine1') }}</div>
            <div class="line1">{{ $t('home.aboutLine2') }}</div>
            <div class="line1">{{ $t('home.aboutLine3') }}</div>
            <div class="line1">{{ $t('home.aboutLine4') }}</div>
          </div>
          <div class="btn" @click="navigateTo(localePath('/about'))">{{ $t('common.learnMore') }}</div>
          <NumberScrolling/>
        </div>
       </div>
       <div class="section">
        <div class="page3">
          <span v-if="state.isShow">
            <div class="title">{{ $t('home.earlyScreening') }}</div>
            <div class="detail">
              <div class="line1" data-aos="flip-left" data-aos-easing="ease-out-cubic" data-aos-duration="2000">{{ $t('home.earlyScreeningDesc') }}</div>
            </div>
            <img class="video_cover" src="@/assets/img/play.png" alt="" @click="onPlay">
          </span>
          <!-- <video src='../assets/12.29.mp4' autoplay controls v-else class="video_con"></video> -->
          <video src='http://jinbaihui-bucket.oss-cn-shenzhen.aliyuncs.com/temp/0a70a9c9978fd348b20e28bc73b8a117.mp4' autoplay controls v-else class="video_con"></video>
        </div>
       </div>
       <div class="section">
        <div class="page4">
          <ProductCenter/>
        </div>
       </div>
       <div class="section">
        <div class="page5">
          <News/>
        </div>
       </div>
       <div class="section fp-auto-height">
        <div class="page6">
        <NewFooter />
        </div>
       </div>
    </div>
    <!-- <GoTop /> -->
  </div>
</template>

<script setup>
const { t, tm, rt, locale } = useI18n()
const localePath = useLocalePath()

useSeoMeta({
  title: t('home.seoTitle'),
  description: t('home.seoDescription'),
  ogTitle: t('meta.siteName'),
  ogDescription: t('home.seoDescription'),
  ogType: 'website',
})

// import fullpage from 'fullpage.js'
import { reactive,ref,onMounted,onUnmounted,watch,nextTick } from 'vue';
import { useAppStore } from '../store/app'
const { setActive } = useAppStore()
const router = useRouter()
const { $aos } = useNuxtApp()
const fullpage_api = ref(null)
const cur_page = ref(null)
// 组件是否已卸载，用于拦截异步加载完成后的 fullpage 初始化
const isUnmounted = ref(false)
const state = reactive({
  titleColor:'#fff',
  isShow:true,
  headerBgc:'rgba(0, 0, 0, 0.04)',
  showLogo:true,
  boxShadows:''
})
const onPlay =()=>{
  state.isShow = !state.isShow
}
const initFullPage =()=>{
      import('fullpage.js').then((fullpage) => {
        // 动态加载期间用户可能已离开首页，此时初始化会污染新页面 DOM
        // （fullpage 会给 html 加 fp-enabled/overflow:hidden 并固定 section 高度）
        if (isUnmounted.value) return
        fullpage_api.value = new fullpage.default('#fullpage', {
          // 插件配置选项
          licenseKey: 'gplv3-license',
          scrollBar: true,
          navigation:true,
          navigationPosition:'right',
          scrollOverflow: true,
          // tm() 返回的是未渲染的消息对象，直接传给 fullpage 会显示为
          // [object Object]，需用 rt() 逐项渲染为字符串
          navigationTooltips: tm('home.tooltips').map((tooltip) => rt(tooltip)),
          afterLoad: function(origin, destination) {
          // 获取当前页码
          cur_page.value = destination.index + 1
          if(cur_page.value===1||cur_page.value===3){
            state.headerBgc = 'rgba(0, 0, 0, 0.04)'
            
            state.showLogo = true
            state.boxShadows = ''
            state.titleColor = '#fff'
          }else{
            state.headerBgc = '#ffffff'
            state.showLogo=false
            state.boxShadows='0px 1px 8px 0px rgba(0,0,0,0.09)'
            state.titleColor = '#000'
          }
          if(cur_page.value!==3){
            state.isShow = true
          }
        },
        })
        bindLastNavFallback()
        // console.log(fullpage_api.value,'fullpage_api');
      })
}

// 最后一个导航点的兜底滚动：
// scrollBar:true 下 fullpage 的原生滚动监听会在末屏（fp-auto-height 页脚）
// 刚占据半屏时就将其标记为激活区块，而 scrollPage 内部又有
// “已处于目标区块则直接 return”的守卫，导致此时点击最后一个导航点
// 无任何响应、页面停在半空。兜底：激活区块已是末屏时直接滚动到页面底部
const bindLastNavFallback =()=>{
  const lastBullet = document.querySelector('#fp-nav ul li:last-child a')
  if(!lastBullet) return
  lastBullet.addEventListener('click', () => {
    const active = fullpage_api.value?.getActiveSection?.()
    const lastIndex = document.querySelectorAll('#fullpage > .section').length - 1
    // v4 中激活区块的 index 为方法，兼容属性形式取值
    const activeIndex = typeof active?.index === 'function' ? active.index() : active?.index
    if(active && activeIndex === lastIndex){
      window.scrollTo({
        top: document.documentElement.scrollHeight - window.innerHeight,
        behavior: 'smooth'
      })
    }
  })
}

// fullpage 只在初始化时渲染一次 tooltip，切换语言后同步更新导航提示文字
const syncNavTooltips =()=>{
  const tooltips = tm('home.tooltips').map((item) => rt(item))
  document.querySelectorAll('#fp-nav .fp-tooltip').forEach((el, i) => {
    if (tooltips[i]) el.textContent = tooltips[i]
  })
}
watch(locale, () => {
  nextTick(syncNavTooltips)
})

const titleClick=(id)=>{
  if (id == 11) {
    setActive(0)
      navigateTo(localePath(`/about`))
    }else if(id==22){
      setActive(0)
      navigateTo(localePath(`/product`))
    } else if (id == 33) {
      navigateTo(localePath(`/health`))
    } else if (id == 44) {
      setActive(0)
      navigateTo(localePath(`/contact`))
    } else {
      navigateTo(localePath(`/newsCenter`))
    }
}
const menuClick =(e,path)=>{
  let id = +e
    navigateTo(path)
    if(path.includes('/about')){
      setActive(+id-1)
      return
    }
    if(path.includes('/product')){
      setActive(+id-6)
      return
    }
    if(path.includes('/health')){
      setActive(0)
      return
    }
    if(path.includes('/contact')){
      setActive(+id-13)
      return
    }
}
    function to(){
      fullpage_api.value?.moveTo(3);
    }
onMounted(() => {
  initFullPage()
  $aos().init({
    easing: 'ease-out-back',
    duration: 2000,
    once: true,
  })
})
onUnmounted(()=>{
   // 标记已卸载，拦截尚未完成的异步初始化
   isUnmounted.value = true
   // 销毁插件，清除 fullpage 注入到 html/body 的类与内联样式
   fullpage_api.value?.destroy('all')
   fullpage_api.value = null
})
</script>

<style lang="less">
.home {
  width: 100%;
  overflow-x: hidden;
  // overflow-y: auto;
 .content{
  .section{
    height: 100vh;
    width: 100%;
  }
  .page2{
      background: url('../assets/img/page_two_bg.png');
      background-size: cover;
      background-position: center;
      width: 100%;
      height: 100vh;
      text-align: center;
      .title{
        font-size: 16px;
        font-family: Alibaba PuHuiTi;
        font-weight: bold;
        color: #333333;
        padding-top: 57px;
      }
      .detail{
        // font-size: 16px;
        margin-top: 24px;
        font-weight: 400;
        color: #333333;
        .line1{
          margin-bottom: 4px;
        }
        .line2{
          margin-bottom: 10px;
        }
        .line3{
          margin-bottom: 2px;
        }
        .line4{
          margin-bottom: 28px;
        }
      }
      .btn{
        width: 58px;
        height: 22px;
        line-height: 22px;
        text-align: center;
        color: #fff;
        font-size:8px;
        background: #00A0E9;
        border: 1px solid #00A0E9;
        border-radius: 11px;
        margin: auto;
        cursor: pointer;
        margin-top: 20px;
        transition: box-shadow 0.3s;
        &:hover {
         box-shadow: 0 0 4px rgba(45, 142, 228, 0.5);
       }
      }
    }
    .page3{
      background: url('../assets/img/page_three_bg.png');
      background-size: cover;
      background-position: center;
      width: 100%;
      height: 100vh;
      text-align: center;
      color: #fff;
      .title{
        font-size: 16px;
        font-family: Alibaba PuHuiTi;
        font-weight: bold;
        padding-top: 77px;
      }
      .detail{
        margin-top: 24px;
        font-weight: 400;
        // color: #333333;
        .line1{
          margin-bottom: 2px;
        }
        .line2{
          margin-bottom: 10px;
        }
      }
      .video_con{
        height: 100vh;
        width: 100vw;
        object-fit: cover;
        // background-color: #fff;
      }
      .video_cover{
        width: 40px;
        height: 40px;
        margin-top: 65px;
        cursor: pointer;
      }
    }
    .page4{
      width: 100%;
      height: 100vh;
      background-color: #fff;
      h1{
        text-align: center;
        margin: auto;
        padding-top: 100px;
      }
    }
    .page5{
      width: 100%;
      height: 100vh;
      background: url('../assets/img/page_five_bg.png');
      background-size: cover;
      background-position: center;
    }
    .page6{
      width: 100%;
      /* 移除固定 42vh 高度与 overflow:hidden，避免裁剪页脚内容；
         高度由 fp-auto-height 按内容自适应 */
    }
 }
}
.fp-right{
  top: 94px !important;
}
.fp-tooltip {
  font-size: 8px !important; /* 修改字体大小 */
  font-weight: 700 !important; /* 修改字体大小 */
  color: #333 !important; /* 修改颜色 */
  margin-top: -100px;
}
/* 隐藏 fullPage.js GPL 版水印（"Made with fullPage.js"）。
   注意：GPLv3 协议要求保留署名，正式商用建议购买商业许可证 */
.fp-watermark {
  display: none !important;
}
/* 隐藏 scrollOverflow 溢出区块的内部滚动条，避免与原生滚动条叠加出现双滚动条；
   区块内容仍可通过鼠标滚轮滚动，滚到边界后 fullPage 正常切换到下一屏 */
.fp-overflow {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE / 旧版 Edge */
}
.fp-overflow::-webkit-scrollbar {
  width: 0;
  height: 0;
  display: none;
}
</style>
